import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

// Although not ideal, all index's here are converted to strings
// This is because the React Bootstrap UI console errors if receiving a number

export const CustomAccordion = ({ defaultIndices = ['0'], className = '', items = [] }) => {
  const [activeIndices, setActiveIndices] = useState(defaultIndices);

  useEffect(() => {
    setActiveIndices(defaultIndices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  const handleToggle = (index) => {
    const stringIndex = `${index}`;
    setActiveIndices(
      (prevActiveIndices) =>
        prevActiveIndices.includes(stringIndex)
          ? prevActiveIndices.filter((i) => i !== stringIndex) // Remove stringIndex if already active
          : [...prevActiveIndices, stringIndex], // Add stringIndex if not active
    );
  };

  return <AccordionUI items={items} className={className} activeIndices={activeIndices} onClick={handleToggle} />;
};

CustomAccordion.propTypes = {
  defaultIndices: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  items: PropTypes.array,
};

export const ControlledAccordion = ({ activeIndices, setActiveIndices, className = '', items = [] }) => {
  const handleToggle = (index) => {
    const stringIndex = `${index}`;
    setActiveIndices(
      (prevActiveIndices) =>
        prevActiveIndices.includes(stringIndex)
          ? prevActiveIndices.filter((i) => i !== stringIndex) // Remove stringIndex if already active
          : [...prevActiveIndices, stringIndex], // Add stringIndex if not active
    );
  };

  return <AccordionUI items={items} className={className} activeIndices={activeIndices} onClick={handleToggle} />;
};

ControlledAccordion.propTypes = {
  activeIndices: PropTypes.arrayOf(PropTypes.string),
  setActiveIndices: PropTypes.func,
  className: PropTypes.string,
  items: PropTypes.array,
};

const AccordionItem = ({ index, title, content, isActive, onClick }) => (
  <Card className={`${isActive ? 'active' : ''}`}>
    <Card.Header onClick={() => onClick(index)}>{title}</Card.Header>
    {isActive && <Card.Body>{content}</Card.Body>}
  </Card>
);

AccordionItem.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  content: PropTypes.any,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

const AccordionUI = ({ items, className, activeIndices, onClick }) => {
  if (!items.length) return null;

  return (
    <div className={`accordion ${className}`}>
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          index={i}
          title={item.title}
          content={item.content}
          isActive={activeIndices.includes(`${i}`)}
          onClick={onClick}
        />
      ))}
    </div>
  );
};

AccordionUI.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  activeIndices: PropTypes.array,
  onClick: PropTypes.func,
};
